"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBlog = void 0;
var React = __importStar(require("react"));
var IconBlog = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M5.99530215,15.9999936 C7.09930155,15.9967936 7.99690107,16.8911931 8.00010107,17.9935925 C8.00330107,19.0991919 7.11210155,19.9951914 6.00810214,19.9999914 C4.90410273,20.0047914 4.00490321,19.1119919 4.00010322,18.0095925 C3.99690322,16.9023931 4.88970274,16.0047936 5.99530215,15.9999936 L5.99530215,15.9999936 Z M14.6656975,19.9999914 L11.5392992,19.9999914 C11.5392992,15.8351937 8.16330098,12.4591955 4.00010322,12.4591955 L4.00010322,9.33279714 C9.89130006,9.33279714 14.6656975,14.1087946 14.6656975,19.9999914 L14.6656975,19.9999914 Z M16.8000964,19.9999914 C16.7968964,12.9311952 11.0672994,7.20319828 4.00010322,7.19999828 L4.00010322,4 C12.8368985,4 20.0000946,11.1647962 20.0000946,19.9999914 L16.8000964,19.9999914 Z" }))); };
exports.IconBlog = IconBlog;
exports.IconBlog.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconBlog;
